module.exports = __webpack_public_path__ + "static/media/73 - Mild High Club - Homage.15b8c1e7.mp3";